/* eslint-disable prefer-destructuring */
import { DeletedRoom } from '@weblite/ts-action/room'

import { eventBasedSynchronizer } from '$logic/lib/sync/event-based'

type DeletedRoomUpdatePatch = Omit<DeletedRoom, 'roomId'>

const synchronizer = eventBasedSynchronizer<DeletedRoomUpdatePatch, true>(
  'deletedRoomsSync',
  { merge: true },
)

export const set = synchronizer.set
export const getAll = synchronizer.getAll
